import { FDCompensationTypes, FDRelationshipTypes } from ".";
import _ from "lodash";
import { FD } from "./FD";

export const getFDsFormatted = (fd: FD, delim: string = ", ") => {
    if (fd.noCommercialInterests)
        return "No commercial interests";

    return fd.commercialInterests.map((ci) => {
        const comps = ci.compensationIds.map((id) => {
            const type = _.find(FDCompensationTypes.Values, (v) => v.id === id);
            return `(${type ? type.code : "_"})`;
        }).join(" ");

        const rels = ci.relationshipIds.map((id) => {
            const type = _.find(FDRelationshipTypes.Values, (v) => v.id === id);
            return `(${type ? type.code : "_"})`;
        }).join(" ");

        return `${ci.company} ${rels} / ${comps}`;
    }).join(delim);
};



// WEBPACK FOOTER //
// ./src/models/financialDisclosure/FDHelper.ts